import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Table } from "react-bootstrap";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import Papa from "papaparse";
import { getAllUserList } from "../../../services/api_function";

export const Alluser = () => {
  const itemsPerPage = 10;
  const [apiData, setApiData] = useState([]);
  const [TotalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [recordStatus, setRecordStatus] = useState("Loading...");
  const [isSearching, setIsSearching] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [tooltipText, setTooltipText] = useState("Copy address");

  const navigate = useNavigate();

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  const handleSearch = (e) => {
    const query = e.target.value.trim().toLowerCase();
    const sanitizedQuery = query.replace(/[\\|^$*+?.(){}[\]]/g, "");
    setSearch(sanitizedQuery);

    if (query === "") {
      setIsSearching(false);
      setFilteredData([]);
    } else {
      const results = apiData.filter((item) =>
        item.user?.toLowerCase().includes(query),
      );
      setFilteredData(results);
      setIsSearching(true);
    }

    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDetails = localStorage.getItem("adminToken");
        const token = userDetails;
        const result = await getAllUserList(
          currentPage,
          itemsPerPage,
          search,
          token,
        );
        console.log(result, "API Response");

        if (result?.status === 404) {
          localStorage.removeItem("adminToken");
          navigate("/login");
          return;
        }

        const users = result?.data || [];
        setApiData(users);
        if (!users[0]) {
          setRecordStatus("No Record");
        }
        setTotalUsers(result?.pagination?.total || 0);
        setTotalPages(result?.pagination?.totalPages || 1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentPage, search]);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          console.log(result.data);
        },
        header: true,
      });
    }
  };

  const displayData = isSearching ? filteredData : apiData;

  return (
    <Fragment>
      <Row>
        <div className="d-flex justify-content-end mb-3">
          <div className="input-group" style={{ maxWidth: "300px" }}>
            <input
              type="search"
              className="form-control"
              placeholder="Search by wallet address..."
              onChange={handleSearch}
            />
          </div>
        </div>

        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title className="text-white">All USERS</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table
                responsive
                className="table table-bordered table-striped table-hover"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>User ID</th>
                    <th>User Wallet</th>
                    <th>Referral ID</th>
                    {/* <th>Referral Wallet</th> */}
                    <th>Total Deposit</th>
                    <th>Total Income</th>
                    <th>Date & Time</th>
                    <th>Dashboard</th>
                  </tr>
                </thead>
                <tbody>
                  {!displayData?.[0] ? (
                    <tr>
                      <td className="text-center" colSpan="9">
                        {recordStatus}
                      </td>
                    </tr>
                  ) : (
                    displayData.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                        <td>{data?.userId}</td>
                        <td>
                          {data?.user?.slice(0, 5)}...{data?.user?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.user)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td>{data?.userId}</td>
                        {/* <td>
                          {data?.referrer_address?.slice(0, 5)}...{data?.referrer_address?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.referrer_address)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td> */}
                        <td>
                          {data?.totalPurchasePackageSum?.toFixed(2) || "0.00"}
                        </td>
                        <td>
                          {data?.totalSlotIncomeSum?.toFixed(2) || "0.00"}
                        </td>
                        <td>
                          {new Date(data?.timestamp * 1000).toLocaleDateString(
                            "en-GB",
                          )}
                        </td>
                        <td>
                          <a
                            href={`https://dforce.biz/dashboard/?userAddress=${data?.user}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-inline-flex align-items-center gap-2 fw-semibold text-decoration-none text-dark"
                            title="Open User Dashboard"
                          >
                            {/* User / Wallet Icon */}
                            <i className="bi bi-wallet2 text-primary"></i>

                            {/* Short Address */}
                            <span>
                              {data?.user?.slice(0, 5)}...
                              {data?.user?.slice(-4)}
                            </span>

                            {/* External Link Icon */}
                            <i
                              className="bi bi-box-arrow-up-right text-muted"
                              style={{ fontSize: 12 }}
                            ></i>
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              <div className="text-center mb-3 col-lg-6 mx-auto">
                <div className="filter-pagination mt-3">
                  <button
                    className="btn border m-2"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    className="btn btn-success border m-2"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>

                  <span className="mx-2">
                    Page {currentPage} of {totalPages}
                  </span>
                  <span className="mx-2">Total Users: {TotalUsers}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Alluser;
